import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'

import wallet from './wallet/wallet'
import navigate from './navigate/navigate'
import notifications from './notifications/notifications'

const reducers = {
	wallet,
	navigate,
	notifications,
}

const middleware = getDefaultMiddleware({
	immutableCheck: false,
	serializableCheck: false,
	thunk: true,
})

export const store = configureStore({
	reducer: { ...reducers },
	middleware,
})

window.store = store
